export const ru = {
    'add-creatives': {
        one:
            'Добавьте формат креатива: {formats} для увеличения охвата аудитории',
        some:
            'Добавьте форматы креативов: {formats} для увеличения охвата аудитории',
        many:
            'Добавьте форматы креативов: {formats} для увеличения охвата аудитории',
        none:
            'Добавьте форматы креативов: {formats} для увеличения охвата аудитории'
    },
    close: 'Закрыть',
    seconds: 'сек.',
    title: 'Загрузите креативы подходящих форматов',
    'title-hint':
        'Рекомендация показывается, потому что нет подходящих креативов для выбранных щитов',
    'video-format': '{width}x{height}, {duration}сек.'
};
